export function CostSummary({ rows, total, sym, testid = "bi-cost" }) {
  const fmt = (v) => `${sym}${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  return (
    <div className="space-y-1 rounded-2xl border-2 border-[#e2b85a] bg-white p-4" data-testid={testid}>
      {rows.filter(Boolean).map(([label, v, tid]) => (
        <div key={label} className="flex justify-between text-base" data-testid={tid}><span>{label}</span><span>{fmt(v)}</span></div>))}
      <div className="flex justify-between border-t-2 border-[#e2b85a] pt-2 text-xl font-bold text-[#7a0f1d]" data-testid={`${testid}-total`}>
        <span>{total[0]}</span><span>{fmt(total[1])}</span>
      </div>
    </div>
  );
}
